/* foil-hover.js · v4 · 2026-07-14 */
/* Cursor-tracking tilt + foil position on desktop (hover), press-and-hold
   tilt on mobile, plus click-to-flip, for every .foil-card on the page.
   Tilt is gated to hover devices for pointer input; touch devices get the
   same tilt via press-and-hold. Flip works everywhere (click / tap /
   keyboard). Safe to load once. */
(function () {
  var canHover = window.matchMedia('(hover: hover)').matches;
  var MAX_TILT = 8;   // degrees
  var HOLD_MS = 150;  // press duration before a touch becomes a hold (tilt)

  // Shared: write pointer/finger position into the tilt + foil variables.
  function applyPointer(card, clientX, clientY) {
    var r = card.getBoundingClientRect();
    var px = (clientX - r.left) / r.width;
    var py = (clientY - r.top) / r.height;
    card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
    card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    card.style.setProperty('--rx', ((px - 0.5) * MAX_TILT * 2).toFixed(1) + 'deg');
    card.style.setProperty('--ry', (-(py - 0.5) * MAX_TILT * 2).toFixed(1) + 'deg');
  }

  // Shared: spring the card back to flat/centered.
  function resetTilt(card) {
    card.style.setProperty('--mx', '50%');
    card.style.setProperty('--my', '50%');
    card.style.setProperty('--rx', '0deg');
    card.style.setProperty('--ry', '0deg');
  }

  // Pause the idle sway (on .foil-scene) while the user is interacting.
  function setInteracting(card, on) {
    var scene = card.closest('.foil-scene');
    if (scene) scene.classList.toggle('foil-interacting', on);
  }

  // Desktop: hover to tilt.
  function bindTilt(card) {
    card.addEventListener('pointerenter', function () {
      setInteracting(card, true);
    });
    card.addEventListener('pointermove', function (e) {
      applyPointer(card, e.clientX, e.clientY);
    });
    card.addEventListener('pointerleave', function () {
      setInteracting(card, false);
      resetTilt(card);
    });
  }

  // Mobile: press-and-hold to tilt (same feel as desktop hover). A quick tap
  // still flips; a sustained hold tilts and suppresses the flip on release.
  function bindHold(card) {
    var holdTimer = null;
    var holding = false;

    card.addEventListener('touchstart', function (e) {
      holding = false;
      holdTimer = setTimeout(function () {
        holding = true;
        card.dataset.foilHeld = '1';   // tells the click handler not to flip
        setInteracting(card, true);
        var t = e.touches[0];
        if (t) applyPointer(card, t.clientX, t.clientY);
      }, HOLD_MS);
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (!holding) return;
      e.preventDefault();              // stop the page scrolling mid-tilt
      var t = e.touches[0];
      if (t) applyPointer(card, t.clientX, t.clientY);
    }, { passive: false });

    function end() {
      clearTimeout(holdTimer);
      if (holding) { holding = false; setInteracting(card, false); resetTilt(card); }  // spring back flat
    }
    card.addEventListener('touchend', end);
    card.addEventListener('touchcancel', end);
  }

  function bindFlip(card) {
    function toggle() { card.classList.toggle('is-flipped'); }

    card.addEventListener('click', function () {
      // If the touch was a hold (tilt), swallow this click and reset the flag.
      if (card.dataset.foilHeld === '1') { card.dataset.foilHeld = '0'; return; }
      toggle();
    });

    // keyboard: Enter / Space when focused
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });

    // make it focusable / announce as a control
    if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'button');
    card.setAttribute('aria-label', 'Flip card');
  }

  function bind(card) {
    if (card.dataset.foilBound) return;
    card.dataset.foilBound = '1';
    if (canHover) bindTilt(card);
    bindHold(card);
    bindFlip(card);
  }

  function init() { document.querySelectorAll('.foil-card').forEach(bind); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
